export default "__VITE_ASSET__DigmGAyq__"